<ng-template
	#ConversionDetailModalTemplate
	class="modal fade"
	tabindex="-1"
	role="dialog"
	aria-labelledby="conversion-detail-modal-label">
	<div class="modal-content">
		<div class="modal-header">
			<div class="col-2">
				<i class="fa-solid fa-spinner fa-spin fa-xl" *ngIf="isLoading"></i>
			</div>
			<div class="col-8">
				<h2
					class="modal-title text-center"
					id="conversion-detail-modal-label">
					Conversion Detail - {{ clientName }}
				</h2>
			</div>
			<div class="col-2 text-right">
				<button
					class="btn btn-outline-dark"
					(click)="closeConversionDetailModal()"
					data-testid="conversion-detail-modal-close">
					Close
				</button>
			</div>
		</div>
		<div class="modal-body">
			<ul class="nav nav-tabs mb-3">
				<li class="nav-item">
					<a
						class="nav-link clickable"
						[ngClass]="isActiveTab('client') ? 'active' : ''"
						role="button"
						(click)="setActiveTab('client')"
						data-testid="conversion-detail-modal-tab-client">
						Carrier ({{ clients.length }})
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link clickable"
						[ngClass]="isActiveTab('debtors') ? 'active' : ''"
						role="button"
						(click)="setActiveTab('debtors')"
						data-testid="conversion-detail-modal-tab-debtors">
						Brokers to Add ({{ missingDebtors.length }})
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link clickable"
						[ngClass]="isActiveTab('existing') ? 'active' : ''"
						role="button"
						(click)="setActiveTab('existing')"
						data-testid="conversion-detail-modal-tab-existing">
						Existing Brokers ({{ existingDebtors.length }})
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link clickable"
						[ngClass]="isActiveTab('notmoving') ? 'active' : ''"
						role="button"
						(click)="setActiveTab('notmoving')"
						data-testid="conversion-detail-modal-tab-not-moving">
						Not Moving ({{ notMovingDebtors.length }})
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link clickable"
						[ngClass]="isActiveTab('invoices') ? 'active' : ''"
						role="button"
						(click)="setActiveTab('invoices')"
						data-testid="conversion-detail-modal-tab-invoices">
						Invoices ({{ invoices.length }})
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link clickable"
						[ngClass]="isActiveTab('invoicenotes') ? 'active' : ''"
						role="button"
						(click)="setActiveTab('invoicenotes')"
						data-testid="conversion-detail-modal-tab-invoice-notes">
						Invoice Notes ({{ invoiceNotes.length }})
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link clickable"
						[ngClass]="isActiveTab('clientnotes') ? 'active' : ''"
						role="button"
						(click)="setActiveTab('clientnotes')"
						data-testid="conversion-detail-modal-tab-client-notes">
						Client Notes ({{ clientNotes.length }})
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link clickable"
						[ngClass]="isActiveTab('documents') ? 'active' : ''"
						role="button"
						(click)="setActiveTab('documents')"
						data-testid="conversion-detail-modal-tab-documents">
						Documents ({{ documents.length }})
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link clickable"
						[ngClass]="isActiveTab('atob') ? 'active' : ''"
						role="button"
						(click)="setActiveTab('atob')"
						data-testid="conversion-detail-modal-tab-atob">
						AtoB Wallets ({{ atoBWallets.length }})
					</a>
				</li>
			</ul>

			<div *ngIf="isActiveTab('client')">
				<div *ngIf="!isLoading && clients.length === 0" class="text-muted">
					No carrier record found.
				</div>
				<div
					class="row border-bottom pb-3 mb-3"
					*ngFor="let client of clients">
					<div class="col-4">
						<div><strong>Carrier</strong></div>
						<div class="text-primary h5">{{ client.clientName }}</div>
						<div>Client # {{ isNull(client.clientNo) }}</div>
						<div>Alt Name: {{ isNull(client.altName) }}</div>
						<div>Source: {{ isNull(client.sourceSystem) }}</div>
					</div>
					<div class="col-4">
						<div><strong>Address</strong></div>
						<div>{{ isNull(client.address1) }}</div>
						<div *ngIf="client.address2">{{ client.address2 }}</div>
						<div>
							{{ isNull(client.city) }}, {{ isNull(client.stateProvince) }}
							{{ isNull(client.zipCode) }}
						</div>
						<div>{{ isNull(client.phone1) }}</div>
						<div>{{ isNull(client.email) }}</div>
					</div>
					<div class="col-4">
						<div><strong>Conversion</strong></div>
						<div>WinFactor ID: {{ isNull(client.winFactorId) }}</div>
						<div>FactorCloud ID: {{ isNull(client.factorCloudId) }}</div>
						<div>Fed Tax #: {{ isNull(client.fedTaxNo) }}</div>
						<div>First Invoice: {{ formatDate(client.firstInvoiceDate) }}</div>
						<div>
							Credit Limit: {{ '$'
							}}{{ client.totalCreditLimit | number: '1.2-2' }}
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="isActiveTab('debtors')">
				<p class="text-muted">
					These brokers are active, or on an invoice with a balance, and have no
					FactorCloud ID, so the migration will create them in FactorCloud.
				</p>
				<div
					*ngIf="!isLoading && missingDebtors.length === 0"
					class="text-muted">
					No brokers are missing in FactorCloud.
				</div>
				<table
					class="table table-sm table-striped"
					*ngIf="missingDebtors.length > 0">
					<thead>
						<tr>
							<th>Broker Name</th>
							<th>Broker #</th>
							<th>MC #</th>
							<th>City</th>
							<th>State</th>
							<th>WinFactor ID</th>
							<th class="text-center">Invoices</th>
							<th class="text-center">Active</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let debtor of missingDebtors">
							<td>{{ debtor.debtorName }}</td>
							<td>{{ isNull(debtor.debtorNo) }}</td>
							<td>{{ isNull(debtor.motorCarrierNo) }}</td>
							<td>{{ isNull(debtor.city) }}</td>
							<td>{{ isNull(debtor.stateProvince) }}</td>
							<td>{{ isNull(debtor.winFactorId) }}</td>
							<td class="text-center">{{ debtor.invoiceCount }}</td>
							<td class="text-center">
								<i
									class="fa-solid"
									[ngClass]="
										debtor.isActive
											? 'fa-circle-check text-success'
											: 'fa-circle-xmark text-danger'
									"></i>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="isActiveTab('existing')">
				<p class="text-muted">
					These brokers are active, or on an invoice with a balance, and already
					exist in FactorCloud, so the migration uses them as they are.
				</p>
				<div
					*ngIf="!isLoading && existingDebtors.length === 0"
					class="text-muted">
					None of this carrier's brokers exist in FactorCloud yet.
				</div>
				<table
					class="table table-sm table-striped"
					*ngIf="existingDebtors.length > 0">
					<thead>
						<tr>
							<th>Broker Name</th>
							<th>Broker #</th>
							<th>MC #</th>
							<th>City</th>
							<th>State</th>
							<th>WinFactor ID</th>
							<th>FactorCloud ID</th>
							<th class="text-center">Invoices</th>
							<th class="text-center">Active</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let debtor of existingDebtors">
							<td>{{ debtor.debtorName }}</td>
							<td>{{ isNull(debtor.debtorNo) }}</td>
							<td>{{ isNull(debtor.motorCarrierNo) }}</td>
							<td>{{ isNull(debtor.city) }}</td>
							<td>{{ isNull(debtor.stateProvince) }}</td>
							<td>{{ isNull(debtor.winFactorId) }}</td>
							<td>{{ isNull(debtor.factorCloudId) }}</td>
							<td class="text-center">{{ debtor.invoiceCount }}</td>
							<td class="text-center">
								<i
									class="fa-solid"
									[ngClass]="
										debtor.isActive
											? 'fa-circle-check text-success'
											: 'fa-circle-xmark text-danger'
									"></i>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="isActiveTab('notmoving')">
				<p class="text-muted">
					These brokers are inactive and only on invoices with no balance, so the
					migration does not move them to FactorCloud.
				</p>
				<div
					*ngIf="!isLoading && notMovingDebtors.length === 0"
					class="text-muted">
					Every broker on this carrier's invoices is moving.
				</div>
				<table
					class="table table-sm table-striped"
					*ngIf="notMovingDebtors.length > 0">
					<thead>
						<tr>
							<th>Broker Name</th>
							<th>Broker #</th>
							<th>MC #</th>
							<th>City</th>
							<th>State</th>
							<th>WinFactor ID</th>
							<th>FactorCloud ID</th>
							<th class="text-center">Invoices</th>
							<th class="text-center">Active</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let debtor of notMovingDebtors">
							<td>{{ debtor.debtorName }}</td>
							<td>{{ isNull(debtor.debtorNo) }}</td>
							<td>{{ isNull(debtor.motorCarrierNo) }}</td>
							<td>{{ isNull(debtor.city) }}</td>
							<td>{{ isNull(debtor.stateProvince) }}</td>
							<td>{{ isNull(debtor.winFactorId) }}</td>
							<td>{{ isNull(debtor.factorCloudId) }}</td>
							<td class="text-center">{{ debtor.invoiceCount }}</td>
							<td class="text-center">
								<i
									class="fa-solid"
									[ngClass]="
										debtor.isActive
											? 'fa-circle-check text-success'
											: 'fa-circle-xmark text-danger'
									"></i>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="isActiveTab('invoices')">
				<p class="text-muted">
					{{ invoices.length }} invoice(s), {{ openInvoiceCount }} still open.
				</p>
				<div *ngIf="!isLoading && invoices.length === 0" class="text-muted">
					No invoices found for this carrier.
				</div>
				<table class="table table-sm table-striped" *ngIf="invoices.length > 0">
					<thead>
						<tr>
							<th>Invoice #</th>
							<th>Broker</th>
							<th>Invoice Date</th>
							<th>Due Date</th>
							<th class="text-right">Invoice Amount</th>
							<th class="text-right">Balance</th>
							<th class="text-center">Status</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let invoice of invoices">
							<td>{{ isNull(invoice.invoiceNo) }}</td>
							<td
								[ngClass]="
									invoice.debtorMissingInFactorCloud
										? 'text-warning font-weight-bold'
										: ''
								"
								[attr.title]="
									invoice.debtorMissingInFactorCloud
										? 'Broker is missing in FactorCloud'
										: null
								">
								{{ isNull(invoice.debtorName) }}
							</td>
							<td>{{ formatDate(invoice.invoiceDate) }}</td>
							<td>{{ formatDate(invoice.dueDate) }}</td>
							<td class="text-right">
								{{ '$' }}{{ invoice.invoiceAmount | number: '1.2-2' }}
							</td>
							<td class="text-right">
								{{ '$' }}{{ invoice.balance | number: '1.2-2' }}
							</td>
							<td class="text-center">
								<span [ngClass]="invoice.isOpen ? 'text-primary' : 'text-muted'">
									{{ invoice.isOpen ? 'Open' : 'Closed' }}
								</span>
							</td>
						</tr>
					</tbody>
					<tfoot>
						<tr class="font-weight-bold" data-testid="conversion-detail-invoice-totals">
							<td colspan="4">Total</td>
							<td class="text-right">
								{{ '$' }}{{ totalInvoiceAmount | number: '1.2-2' }}
							</td>
							<td class="text-right">
								{{ '$' }}{{ totalBalance | number: '1.2-2' }}
							</td>
							<td></td>
						</tr>
					</tfoot>
				</table>
			</div>

			<div *ngIf="isActiveTab('invoicenotes')">
				<p class="text-muted">
					WinFactor notes on the invoices that move. Step 10 adds each invoice's
					notes to that invoice in FactorCloud.
				</p>
				<div *ngIf="!isLoading && invoiceNotes.length === 0" class="text-muted">
					None of the moving invoices have WinFactor notes.
				</div>
				<table
					class="table table-sm table-striped"
					*ngIf="invoiceNotes.length > 0">
					<thead>
						<tr>
							<th>Invoice #</th>
							<th>Note Date</th>
							<th>User</th>
							<th>Type</th>
							<th>Note</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let invoiceNote of invoiceNotes">
							<td class="text-nowrap">{{ isNull(invoiceNote.invoiceNo) }}</td>
							<td class="text-nowrap">{{ formatDate(invoiceNote.noteDate) }}</td>
							<td>{{ isNull(invoiceNote.userName) }}</td>
							<td>{{ isNull(invoiceNote.noteType) }}</td>
							<td style="white-space: pre-wrap">{{ isNull(invoiceNote.note) }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="isActiveTab('clientnotes')">
				<p class="text-muted">
					WinFactor notes on the carrier. Step 4 adds them to the FactorCloud
					client's General Notes.
				</p>
				<div *ngIf="!isLoading && clientNotes.length === 0" class="text-muted">
					This carrier has no WinFactor client notes.
				</div>
				<table
					class="table table-sm table-striped"
					*ngIf="clientNotes.length > 0">
					<thead>
						<tr>
							<th>Note Date</th>
							<th>User</th>
							<th>Type</th>
							<th>Note</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let clientNote of clientNotes">
							<td class="text-nowrap">{{ formatDate(clientNote.noteDate) }}</td>
							<td>{{ isNull(clientNote.userName) }}</td>
							<td>{{ isNull(clientNote.noteType) }}</td>
							<td style="white-space: pre-wrap">{{ isNull(clientNote.note) }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="isActiveTab('documents')">
				<p class="text-muted">
					WinFactor client documents in the carrier's blob storage folder. Step 7 refreshes
					the folder and sends each document not yet in FactorCloud to the
					FactorCloud client, typed from its file name. {{ documentsToSendCount }}
					to send.
				</p>
				<div *ngIf="isLoadingDocuments" class="text-muted">
					<i class="fa-solid fa-spinner fa-spin"></i> Loading documents...
				</div>
				<div
					*ngIf="!isLoadingDocuments && documents.length === 0"
					class="text-muted">
					No documents are imported for this carrier. Run the Client Documents
					import to pick up its folder.
				</div>
				<table
					class="table table-sm table-striped"
					*ngIf="documents.length > 0">
					<thead>
						<tr>
							<th>File Name</th>
							<th>Type</th>
							<th class="text-right">Size</th>
							<th>Last Modified</th>
							<th>Status</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let document of documents">
							<td>{{ isNull(document.documentFileName) }}</td>
							<td>
								{{
									isNull(
										document.factorCloudDocumentType ||
											document.inferredDocumentType
									)
								}}
							</td>
							<td class="text-right text-nowrap">
								{{ formatFileSize(document.fileSizeBytes) }}
							</td>
							<td class="text-nowrap">
								{{ formatDate(document.blobLastModifiedDate) }}
							</td>
							<td class="text-nowrap">
								<span
									[ngClass]="
										document.sentToFactorCloudDate ? 'text-muted' : 'text-primary'
									">
									{{
										document.sentToFactorCloudDate
											? 'Sent ' + formatDate(document.sentToFactorCloudDate)
											: 'Will be sent'
									}}
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="isActiveTab('atob')">
				<p class="text-muted">
					Active AtoB wallets whose company name matches the carrier (its
					FactorCloud name once converted). Step 1 adds each as an "AtoB Wallet"
					DIGITAL WALLET funding instruction. Deactivated wallets are left out.
				</p>
				<div *ngIf="isLoadingAtoB" class="text-muted">
					<i class="fa-solid fa-spinner fa-spin"></i> Loading AtoB wallets...
				</div>
				<div
					*ngIf="!isLoadingAtoB && atoBWallets.length === 0"
					class="text-muted">
					No active AtoB wallet matches this carrier.
				</div>
				<table
					class="table table-sm table-striped"
					*ngIf="atoBWallets.length > 0">
					<thead>
						<tr>
							<th>AtoB ID</th>
							<th>Company Name</th>
							<th>Pay To</th>
							<th>Wallet Status</th>
							<th>Funding Instruction</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let wallet of atoBWallets">
							<td>{{ wallet.atoBId }}</td>
							<td>{{ isNull(wallet.companyName) }}</td>
							<td>{{ isNull(wallet.payTo) }}</td>
							<td>{{ isNull(wallet.walletStatus) }}</td>
							<td>{{ isNull(wallet.factorCloudFundingInstructionId) }}</td>
							<td class="text-nowrap">
								<span
									[ngClass]="
										wallet.fundingInstructionSentDate ? 'text-muted' : 'text-primary'
									">
									{{ atoBWalletAction(wallet) }}
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/portal/conversion/conversion-detail-modal/conversion-detail-modal.component.html